export const NewsDetail = () => {}
